import { useEffect, useState } from 'react';
import { FieldError } from 'react-hook-form';
import cx from 'classnames';
import { forwardRef } from 'react';

import { CheckMark } from 'src/components/Icons/icons';
import { Error } from './Input';

type CheckBoxProps = Omit<
    React.InputHTMLAttributes<HTMLInputElement>,
    'type'
> & {
    label: string;
    error?: FieldError;
    helperText?: string;
};

const CheckBox = forwardRef<HTMLInputElement, CheckBoxProps>(
    ({ label, error, helperText, disabled, className, ...props }, ref) => (
        <div className={cx('space-y-1', className)}>
            <label
                className={cx(
                    'flex items-center gap-2 text-sm',
                    disabled ? 'text-mongooseGray' : 'text-woodyBrown',
                )}
            >
                <input
                    type="checkbox"
                    className="peer hidden"
                    disabled={disabled}
                    ref={ref}
                    {...props}
                />
                <span
                    className={cx(
                        'relative inline-flex h-5 w-5 items-center justify-center rounded border transition-colors flex-shrink-0',
                        'border-mongooseGray bg-white text-transparent peer-checked:border-woodyBrown peer-checked:bg-woodyBrown peer-checked:text-lightPeach',
                        disabled && 'opacity-70',
                    )}
                >
                    <span className="absolute inset-0 flex items-center justify-center transition-colors text-lightPeach checked:text-transparent">
                        <CheckMark />
                    </span>
                </span>
                <span>{label}</span>
            </label>
            {helperText && (
                <p className="text-xs text-mongooseGray">{helperText}</p>
            )}
            <Error error={error} />
        </div>
    ),
);

CheckBox.displayName = 'CheckBox';

export default CheckBox;
